module.exports = __webpack_public_path__ + "static/media/5.3ffa3f81.png";